import type { PropsWithChildren } from 'react';
import React from 'react';
import { classNames } from '../utils';
import * as styles from '../css/details-list.css';
import ImportantText from './ImportantText';

interface DetailsListProps {
    className?: string;
    children: React.ReactNode;
    subtitle?: string;
}

const DetailsList = ({ children, subtitle, className }: PropsWithChildren<DetailsListProps>) => (
    <>
        {subtitle && (
            <div className={styles.subtitle}>
                <ImportantText>{subtitle}</ImportantText>
            </div>
        )}
        <ul className={classNames(styles.root, className)}>
            {children}
        </ul>
    </>
);

export default DetailsList;
